// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"646":"c9391c84","890":"c9391c84","894":"420cf404","956":"36872260","981":"c9391c84"}[chunkId] + ".chunk.css";
};